import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetSports = QueryFactory(SD.QueryTypes.GetSports);
//# sourceMappingURL=QGetSports.js.map